import { Plus } from 'lucide-react';
import React, { useEffect, useState } from 'react';
// import './patientList.css'
import {
    Button,
    ButtonGroup,
    Card,
    Col,
    Container,
    Form,
    Image,
    Modal,
    Row,
    Spinner,
    Stack,
    Table,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { formatDate } from '../../helper';
import { useBackOfficeAddMutation } from './backOfficeApi';

const AddBackOffice = ({ setLoading, edit, setEdit }) => {
    const config = {
        email: '',
        password: '',
        mobile: '123456',
        userType: 'BACKOFFICE',
        languageId: 1,
        name: '',
        lastName: '',
        dateOfBirth: '',
        doYouWearGlasses: true,
        whenIsTheLastTimeYouWentToTheEyeDoctor: '',
        patientNameOfYourUsualEyeDoctor: '',
        patientRppsNumberOfYourUsualEyeDoctor: 0,
        phoneNumber: 0,
        typeOfVision: '',
        patientHappy: '',
        patientSymptoms: '',
        patientDiagnosedWith: '',
        patientHealthConditions: '',
        additionalComments: '',
        doctorRppsNumber: '',
        doctorIdOfRegistration: '',
        doctorAddressOfTheHealthCenter: '',
        SubmitTrack: 'Web',
        infoSSN: '',
    };
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [backOfficeConfig, setBackOfficeConfig] = useState(config);
    const initialValue = {
        name: false,
        email: false,
        password: false,
    };
    const [inputStatus, setInputStatus] = useState(initialValue);
    const [addBackOffice] = useBackOfficeAddMutation();

    useEffect(() => {
        console.log('backOfficeConfig ===', backOfficeConfig);
    }, [backOfficeConfig]);

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setBackOfficeConfig((prevValues) => {
            return {
                ...prevValues,
                [name]: value,
            };
        });

        setInputStatus((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (
            backOfficeConfig.name &&
            backOfficeConfig.email &&
            backOfficeConfig.password
        ) {
            setModalLoading(true);
            console.log('handle submit - ture case');
            try {
                let { data } = await addBackOffice({ ...backOfficeConfig });
                console.log(data);
                if (data) {
                    setShow(false);
                    setLoading(true);
                }
            } catch (error) {
                console.log(error, 'errorerror');
            } finally {
                setModalLoading(false);
            }
        } else {
            console.log('handle submit - false case');
            const updatedStatus = { ...inputStatus };

            if (backOfficeConfig.name === '') updatedStatus.name = true;
            if (backOfficeConfig.email === '') updatedStatus.email = true;
            if (backOfficeConfig.password === '') updatedStatus.password = true;

            setInputStatus(updatedStatus);
        }
    };

    return (
        <>
            <Button variant="primary" onClick={() => setShow(true)}>
                <Plus width={14} height={14} />
                {t('addBackOffice')}
            </Button>
            <Modal
                show={show}
                // size="lg"
                onHide={() => {
                    setInputStatus(initialValue);
                    setShow(false);
                }}
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Form noValidate onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t('addBackOffice')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal_form">
                        <Row>
                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('name')} *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={backOfficeConfig.name}
                                        onChange={handleChange}
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.name}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('name')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('email')} *</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={backOfficeConfig.email}
                                        onChange={handleChange}
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.email}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('email')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col md={12}>
                                <Form.Group className="">
                                    <Form.Label>{t('password')} *</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="password"
                                        value={backOfficeConfig.password}
                                        onChange={handleChange}
                                        placeholder={t('inputText')}
                                        isInvalid={inputStatus.password}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t('password')} {t('isRequired')}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                setShow(false);
                            }}
                        >
                            {t('cancel')}
                        </Button>
                        {/* <Button variant="primary" type="submit">Add new sheet</Button> */}
                        <Button
                            type="submit"
                            variant="primary"
                            disabled={modalLoading}
                        >
                            {modalLoading && (
                                <Spinner
                                    animation="border"
                                    role="status"
                                    size="sm"
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </Spinner>
                            )}{' '}
                            {t('addNewSheet')}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
};

export default AddBackOffice;
